import React from "react";

const API_BASE = process.env.REACT_APP_API_URL || "https://go.brandhives.com";
const G = "#0077B5";
const CARD = "#FFFFFF";
const B = "#E1E9EE";
const RED = "#D85A30";

const SectionLabel = ({ children }) => (
  <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 12, letterSpacing: "0.2em", color: "#999999", textTransform: "uppercase", marginBottom: 16 }}>{children}</div>
);

export default function WorkspacesTab({ user, dashState, onNavigateTeam }) {
  if (user?.is_workspace_admin) {
    return (
      <div>
        <SectionLabel>Your workspace</SectionLabel>
        <div style={{ background: CARD, border: `1px solid ${B}`, borderRadius: 10, padding: "20px", marginBottom: 20 }}>
          <div style={{ fontSize: 15, marginBottom: 8 }}>You have an active workspace.</div>
          <button onClick={onNavigateTeam} style={{ background: G, color: "#fff", border: "none", borderRadius: 6, padding: "10px 22px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 14, cursor: "pointer", minHeight: 44 }}>Open workspace dashboard →</button>
        </div>
      </div>
    );
  }

  if (user?.is_workspace_member) {
    return null;
  }

  // Not a workspace member — show create workspace CTA
  return (
    <div>
      <SectionLabel>Post for your whole team — automatically</SectionLabel>
      <div style={{ background: CARD, border: `1px solid ${B}`, borderRadius: 12, padding: "28px 24px", marginBottom: 24 }}>
        <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 16 }}>Teams by BrandHives</div>
        <ul style={{ fontSize: 14, color: "#555", lineHeight: 2.2, paddingLeft: 18, marginBottom: 24 }}>
          <li>Every team member gets their own LinkedIn schedule</li>
          <li>Posts written in each person's voice</li>
          <li>One weekly plug post for the whole team</li>
          <li>Centralized billing — team members never see costs</li>
          <li>Full analytics across your entire team</li>
        </ul>
        <div style={{ background: "#f8f7f5", borderRadius: 10, padding: "20px", marginBottom: 20, textAlign: "center" }}>
          <div style={{ display: "flex", gap: 16, justifyContent: "center" }}>
            <div>
              <div style={{ fontSize: 12, color: "#888" }}>Starting from</div>
              <div style={{ fontSize: 24, fontWeight: 800, color: "#1a1a1a" }}>$298<span style={{ fontSize: 13, fontWeight: 400, color: "#888" }}>/mo</span></div>
              <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>Authority Team · $149/seat · min 2</div>
            </div>
            <div style={{ borderLeft: "1px solid #e0dfdc" }} />
            <div>
              <div style={{ fontSize: 12, color: "#888" }}>Starting from</div>
              <div style={{ fontSize: 24, fontWeight: 800, color: "#1a1a1a" }}>$398<span style={{ fontSize: 13, fontWeight: 400, color: "#888" }}>/mo</span></div>
              <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>Authority Pro · $199/seat · min 2</div>
            </div>
          </div>
        </div>
        <button onClick={async () => { const name = window.prompt("Name your workspace (company or team name):"); if (!name || !name.trim()) return; try { const r = await fetch(`${API_BASE}/app/api/workspace/create`, { method: "POST", headers: { "Content-Type": "application/json", "X-Session-Token": localStorage.getItem("nectar_st") }, body: JSON.stringify({ name: name.trim() }) }); const d = await r.json(); if (r.ok && d.workspace_id) { window.location.hash = `/workspace/${d.workspace_id}`; } else { alert(d.error || "Failed to create workspace"); } } catch { alert("Error creating workspace"); } }} style={{ background: G, color: "#fff", border: "none", borderRadius: 8, padding: "14px 28px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 15, fontWeight: 600, cursor: "pointer", minHeight: 48, width: "100%" }}>Create my workspace →</button>
      </div>
    </div>
  );
}
